import { ColDef } from 'ag-grid-community';
import { t } from 'i18next';

import { AgGridFilterOption, LinkTarget } from 'core/enums';
import { formatDate } from 'core/utils';
import { QuoteIdCell, QuoteStateCell } from 'quotes/elements';
import { QuoteState } from 'quotes/enums';

export const columnDef = (): ColDef[] => [
  {
    colId: 'vendorQuoteNumber',
    headerName: t('headerVendorQuote'),
    width: 200,
    field: 'externalNumber',
    filter: 'agTextColumnFilter',
    pinned: 'left',
    lockPinned: true,
  },
  {
    colId: 'id',
    headerName: t('headerQuoteId'),
    field: 'id',
    filter: 'agTextColumnFilter',
    pinned: 'left',
    lockPinned: true,
    cellRenderer: QuoteIdCell,
    cellRendererParams: {
      target: LinkTarget.BLANK,
    },
  },
  {
    colId: 'vendor',
    headerName: t('headerVendor'),
    field: 'vendorContactGroupName',
    filter: 'agTextColumnFilter',
  },
  {
    colId: 'contact',
    headerName: t('headerContact'),
    field: 'vendorContactName',
    filter: 'agTextColumnFilter',
  },
  {
    colId: 'job',
    headerName: t('headerJob'),
    width: 200,
    field: 'jobName',
    filter: 'agTextColumnFilter',
  },
  {
    colId: 'project',
    headerName: t('headerProject'),
    width: 200,
    field: 'customerProjectName',
    filter: 'agTextColumnFilter',
  },
  {
    colId: 'vendorProject',
    headerName: t('headerVendorProject'),
    width: 200,
    field: 'externalProjectName',
    filter: 'agTextColumnFilter',
  },
  {
    colId: 'startDate',
    headerName: t('headerEffectiveDate'),
    field: 'startDate',
    filter: 'agDateColumnFilter',
    filterParams: {
      defaultOption: AgGridFilterOption.GREATER_THAN,
      includeBlanksInLessThan: true,
    },
    valueFormatter: ({ value }) => formatDate(value),
  },
  {
    colId: 'expiryDate',
    headerName: t('headerExpiryDate'),
    field: 'validUntil',
    filter: 'agDateColumnFilter',
    filterParams: {
      defaultOption: AgGridFilterOption.GREATER_THAN,
      includeBlanksInGreaterThan: true,
    },
    valueFormatter: ({ value }) => formatDate(value),
  },
  {
    colId: 'attachedTo',
    headerName: t('headerAttachedTo'),
    field: 'attachedTo',
    filter: 'agSetColumnFilter',
    valueGetter: ({ data }) => {
      if (data?.quoteQuoteAssociationId) {
        return t('labelAttachedToQuote');
      }

      if (data?.projectQuoteAssociationId) {
        return t('labelAttachedToProject');
      }

      if (data?.vendorCostStructureQuoteAssociationId) {
        return t('labelAttachedToCostingProfile');
      }

      if (data) {
        return t('labelAttachedToJob');
      }
    },
  },
  {
    colId: 'archived',
    headerName: t('headerQuoteState'),
    field: 'archived',
    cellRenderer: QuoteStateCell,
    filter: 'agSetColumnFilter',
    filterParams: {
      suppressSelectAll: true,
      values: [QuoteState.ACTIVE, QuoteState.ARCHIVED],
    },
    filterValueGetter: ({ data }) =>
      data?.archived === 1 ? QuoteState.ARCHIVED : QuoteState.ACTIVE,
    sortable: false,
  },
];
